export default __webpack_public_path__ + "static/media/igem-logo-dark-bg.824f4df1.svg";